import React from "react";
import { ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function Blog({ content = {}, articles = [] }) {
  const { ref, cls } = useReveal();
  if (!articles || articles.length === 0) return null;
  return (
    <section className="bg-[#f6f8fb] py-24">
      <div ref={ref} className={`max-w-[1180px] mx-auto px-6 ${cls}`}>
        <h2 className="gp-heading text-[2.2rem] sm:text-[2.6rem] mb-12">{content.blog_title || "What\u2019s new"}</h2>
        <div className="grid md:grid-cols-3 gap-7">
          {articles.slice(0, 3).map((p) => (
            <a
              key={p.id || p.title}
              href="#"
              className="group bg-white rounded-2xl overflow-hidden shadow-[0_10px_30px_rgba(20,30,55,0.07)] hover:shadow-[0_20px_45px_rgba(20,30,55,0.14)] transition-all duration-300 hover:-translate-y-1"
            >
              <div className="overflow-hidden h-52 bg-gray-100">
                {p.image && <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
              </div>
              <div className="p-6">
                <span className="text-[#2ec9c9] text-[0.78rem] font-semibold uppercase tracking-wide">{p.tag}</span>
                <h3 className="text-[#16243b] font-semibold text-[1.2rem] leading-snug mt-2 group-hover:text-[#1fb0b0] transition-colors">
                  {p.title}
                </h3>
                <p className="text-[#5a6b80] text-[0.92rem] leading-relaxed mt-3 line-clamp-3">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-[#16243b] font-medium text-[0.9rem] mt-4 group-hover:gap-2 transition-all">
                  Read more <ArrowRight size={16} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
